import App from "~/App.vue"

import { registerPlugins } from "~/plugins"
import "maz-ui/styles"

import { createApp } from "vue"

import { VueSignaturePad } from "vue-signature-pad"

// import L from "leaflet"

import "./sass/app.scss"

console.log("Welcome to the app...")

const app = createApp(App)
registerPlugins(app)

app.component("VueSignaturePad", VueSignaturePad)

app.mount("#app")
